import { render, staticRenderFns } from "./ApplicationFlowKYCChoose.vue?vue&type=template&id=3d0d0428&scoped=true&"
import script from "./ApplicationFlowKYCChoose.vue?vue&type=script&lang=js&"
export * from "./ApplicationFlowKYCChoose.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFlowKYCChoose.vue?vue&type=style&index=0&id=3d0d0428&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0d0428",
  null
  
)

export default component.exports